<micro-select-combo #sel
              placeholder="Payment Carrier"
              routerBase="pay/paymentCarriers"
              [mode]="mode"
              [(id)]="paymentCarrierId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
